function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  stroke: "#F4F4F4",
  d: "M.5.5h91v185H.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  stroke: "#F4F4F4",
  d: "M10.5 10.5h72v175h-72z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M21 106h51v64H21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  stroke: "#F4F4F4",
  d: "M21.5 106.5h50v63h-50zM71.5 90.5v-47c0-13.807-11.193-25-25-25s-25 11.193-25 25v47h50z"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#D7D7D7",
  cx: 18.5,
  cy: 98.5,
  r: 4,
  stroke: "#F4F4F4"
}));

function SvgRoomSceneryDoor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 186,
    viewBox: "0 0 92 186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomSceneryDoor);
export default __webpack_public_path__ + "static/media/RoomSceneryDoor.ff651a0a.svg";
export { ForwardRef as ReactComponent };